import React,{useState,useEffect,useContext} from 'react'
import { ManagerAuthConsultant } from "../context/AuhConsultant";
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";

export const LoginConsultant = () => {
  
  const { login } = useContext(ManagerAuthConsultant);
  
  const [inputs, setInput] = useState({
    tel: "",
    password: "",
  });
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
        await login(inputs);
        navigate("/PanelConsultantRps/DasheboardCons");
    } catch (err) {
     toast.warning(
       "نام کاربری یا کلمه عبور اشتباه میباشد"
     );
     toast.warning("دسترسی شما به سیستم توسط مدیر غیر فعال میباشد")
    }
  
  };

  return (
   <>
      <div class="container-fluid wrapper" dir='rtl'>
    <div class="row d-flex align-items-center justify-content-center h-100 position-relative">
      <div class="col-sm-12 auth-responsive d-flex d-xl-none">
        <img src="../img/WLogo.png" width="200" alt="" />
      </div>
      <div class="col-sm-12 col-xl-3 d-flex justify-content-center align-items-center p-24">
        <div class="card auth-shadow login-card position-relative order-1">
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1" />
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec2" />
          <img src="../img/Rec01.png" alt="" class="position-absolute order-0 auth-rec1 bottom-0" />
          <div class="card-header bg-white border-0 p-0">
            <div class="card-title text-center">
              <h1>حسابتو پیدا کن</h1>
              <p>لطفا اطلاعات خود را وارد کنید تا به ما بپیوندید!</p>
            </div>
          </div>
          <div class="card-content auth-card">
            <div class="form-group position-relative d-flex align-items-center justify-content-center mb-0">
              <i class="zmdi zmdi-account"></i>
              <input name="tel" type="text" class="form-control" placeholder="نام کاربری" onChange={handleChange}/>
            </div>
            <div class="form-group position-relative d-flex align-items-center justify-content-center">
              <i class="zmdi zmdi-lock"></i>
              <input name="password" type="password" maxLength={12} class="form-control" placeholder="کلمه عبور" onChange={handleChange}/>
            </div>
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center t-24">
              <div class="d-flex justify-content-center align-items-center mb-2 mb-md-0">
                <input type="checkbox" class="form-check-input" />
                <p class="my-0 mx-2">منو یادت باشه</p>
              </div>
              <Link to="/getNumber">کلمه عبورتو فراموش کردی؟</Link>
            </div>
            <button class="custom-btn-primary t-24 w-100" onClick={handleSubmit}>
              ورود به حساب کاربری
            </button>
            <p class="t-24 text-center mb-0">
              حساب نداری؟ <Link to="/register">حساب جدید</Link>
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xl-9 d-none d-xl-flex justify-content-center align-items-center p-24 h-100 pr-0">
        <div class="auth-section-img position-relative d-flex justify-content-center align-items-center">
          <div class="position-absolute d-flex flex-column justify-content-center align-items-center">
            <img src="./img/WLogo.png" width="250" alt="" />
            <div class="d-flex flex-column">
              <h2>STUDENT MEDICAL UNIT</h2>
              <h3>پرونده بالینی دانش آموزان</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
   </>
  )
}
